import { LOCATION_CHANGE } from './../actions';
import {
  jobNames,
  pageTypes,
  dispatcherTypes,
  metricsPagesHelper
} from './../helpers';
import {
  artifactsMetricsPageReducer,
  caseAmendingPerformancePageReducer,
  caseAmendingKppPerformancePageReducer,
  caseMetricsPageReducer,
  engineMetricsPageReducer,
  exportPerformancePageReducer,
  performanceMetricsPageReducer,
  releaseMetricsPageReducer,
  jobBenchmarkPerformancePageReducer
} from './../reducers';

const initialState = {
  dispatcherType: '',
  pageType: {},
  jobName: '',
  dispatcherJobName: ''
};

const metricsPage = (state = initialState, action) => {
  if (action.type === LOCATION_CHANGE) {
    if (!action.payload) {
      return state;
    }
    switch (action.payload.pathname) {
      case '/case-metrics':
        return {
          ...state,
          pageType: pageTypes.CASEMETRICS,
          dispatcherType: dispatcherTypes.CASEMETRICS,
          jobName: jobNames.CASE_METRICS,
          dispatcherJobName: jobNames.CASE_METRICS_DISPATCHER,
          metricsInfo: (s) => caseMetricsPageReducer.getCaseMetricsInfo(s),
          selectedJobs: (s) => caseMetricsPageReducer.getCaseSelectedJobs(s),
          dropdownPairFirstSelected: (s) =>
            caseMetricsPageReducer.getCaseDropdownFirstSelected(s)
        };
      case '/performance-metrics':
        return {
          ...state,
          pageType: pageTypes.PERFORMANCEMETRICS,
          dispatcherType: dispatcherTypes.PERFORMANCETESTS,
          jobName: jobNames.PERFORMANCE,
          dispatcherJobName: jobNames.PERFORMANCE_DISPATCHER,
          metricsInfo: (s) => performanceMetricsPageReducer.getPerformanceMetricsInfo(s),
          selectedJobs: (s) =>
            performanceMetricsPageReducer.getPerformanceSelectedJobs(s),
        };
      case '/case-amending-performance':
        return {
          ...state,
          pageType: pageTypes.CASEAMENDINGTESTS,
          dispatcherType: dispatcherTypes.CASEAMENDINGTESTS,
          jobName: jobNames.CASE_AMENDING,
          dispatcherJobName: jobNames.CASE_AMENDING_DISPATCHER,
          metricsInfo: (s) =>
            caseAmendingPerformancePageReducer.getCaseAmendingPerformanceInfo(s),
          selectedJobs: (s) =>
            caseAmendingPerformancePageReducer.getCaseAmendingPerformanceSelectedJobs(s)
        };
      case '/case-amending-kpp-performance':
        return {
          ...state,
          pageType: pageTypes.CASEAMENDINGKPPTESTS,
          dispatcherType: dispatcherTypes.CASEAMENDINGTESTS,
          jobName: jobNames.CASE_AMENDING_KPP,
          dispatcherJobName: jobNames.CASE_AMENDING_KPP_DISPATCHER,
          metricsInfo: (s) =>
            caseAmendingKppPerformancePageReducer.getCaseAmendingKppPerformanceInfo(s),
          selectedJobs: (s) =>
            caseAmendingKppPerformancePageReducer
              .getCaseAmendingKppPerformanceSelectedJobs(s)
        };
      case '/export-performance':
        return {
          ...state,
          pageType: pageTypes.EXPORTTESTS,
          dispatcherType: dispatcherTypes.EXPORTTESTS,
          jobName: jobNames.EXPORT,
          dispatcherJobName: jobNames.EXPORT_DISPATCHER,
          metricsInfo: (s) => exportPerformancePageReducer.getExportPerformanceInfo(s),
          selectedJobs: (s) =>
            exportPerformancePageReducer.getExportPerformanceSelectedJobs(s)
        };
      case '/job-benchmark-performance':
        return {
          ...state,
          pageType: pageTypes.JOBBENCHMARK,
          dispatcherType: dispatcherTypes.JOBBENCHMARK,
          jobName: jobNames.JOBBENCHMARK,
          dispatcherJobName: jobNames.JOB_BENCHMARK_DISPATCHER,
          metricsInfo: (s) => jobBenchmarkPerformancePageReducer
            .getJobBenchmarkPerformanceInfo(s),
          selectedJobs: (s) =>
            jobBenchmarkPerformancePageReducer.getJobBenchmarkPerformanceSelectedJobs(s)
        };
      case '/artifacts-metrics':
        return {
          ...state,
          pageType: pageTypes.ARTIFACTSMETRICS,
          dispatcherType: dispatcherTypes.CASEMETRICS,
          jobName: jobNames.CASE_METRICS,
          dispatcherJobName: jobNames.CASE_METRICS_DISPATCHER,
          metricsInfo: (s) => artifactsMetricsPageReducer.getArtifactsMetricsInfo(s),
          selectedJobs: (s) => artifactsMetricsPageReducer.getArtifactsSelectedJobs(s)
        };
      case '/release-metrics':
        return {
          ...state,
          pageType: pageTypes.RELEASEMETRICS,
          metricsInfo: (s) => releaseMetricsPageReducer.getReleaseMetricsInfo(s),
          selectedJobs: (s) => releaseMetricsPageReducer.getReleaseMetricsSelectedJobs(s)
        };
      case '/engine-metrics':
        return {
          ...state,
          pageType: pageTypes.ENGINEMETRICS,
          dispatcherType: dispatcherTypes.CASEMETRICS,
          jobName: jobNames.CASE_METRICS,
          dispatcherJobName: jobNames.ENGINE_METRICS_DISPATCHER,
          metricsInfo: (s) => engineMetricsPageReducer.getEngineMetricsInfo(s),
          selectedJobs: (s) => engineMetricsPageReducer.getEngineMetricsSelectedJobs(s),
          dropdownPairFirstSelected: (s) =>
            engineMetricsPageReducer.getEngineDropdownFirstSelected(s)
        };
      default:
        return initialState;
    }
  }
  return state;
};

export default metricsPage;

export const getMetricsPage = state => state.metricsPage;
export const getMetricsPageType = state => getMetricsPage(state).pageType;
export const getMetricsDispatcherType = state => getMetricsPage(state).dispatcherType;
export const getMetricsJobName = state => getMetricsPage(state).jobName;
export const getMetricsPageInfo = state => getMetricsPage(state).metricsInfo(state);
export const getMetricsDispatcherJobName = state =>
  getMetricsPage(state).dispatcherJobName;
export const getMetricsPageSelectedJob = state =>
  getMetricsPage(state).selectedJobs(state);
export const getMetricsPageDropdownFirstSelected = state => {
  const selectedFunc = getMetricsPage(state).dropdownPairFirstSelected;
  return selectedFunc ? selectedFunc(state) : '';
};

export const getMetricsOutliersShown = state => {
  if ( getMetricsPage(state).pageType === pageTypes.CASEMETRICS) {
    return caseMetricsPageReducer.getCaseMetricsOutliersShown(state);
  } else if (getMetricsPage(state).pageType === pageTypes.ENGINEMETRICS) {
    return engineMetricsPageReducer.getEngineMetricsOutliersShown(state);
  } else {
    return performanceMetricsPageReducer.getPerformanceMetricsOutliersShown(state);
  }
};
export const getParamsActionNames = state =>
  metricsPagesHelper.getParamsActionNames(getMetricsPage(state).pageType);
export const getMetricsActionNames = (state) =>
  metricsPagesHelper.getMetricsActionNames(getMetricsPage(state).pageType);

export const getMetricsPageLastSelectedJob = state => {
  const selectedJobs = getMetricsPageSelectedJob(state);
  return selectedJobs.length !== 0 ?
    selectedJobs[selectedJobs.length - 1] :
    null;
};




// WEBPACK FOOTER //
// src/reducers/metricsPage.js